import React from 'react';

import "./periodrender.css"

export default function PeriodRender (props) {
  return <div className="period-caption ">From {props.from}<br/>To {props.to}</div>;
}

